import { AppBanner } from '../AppBanner/AppBanner'
import CookiesDialog from '../CookiesDialog/CookiesDialog'
import DialogService from '../Dialogs/DialogService'

interface IProps {
    Link: any
}

export const AuxiliaryWrapper: React.FC<IProps> = ({ Link }) => {
    return (
        <>
            <DialogService />
            <CookiesDialog Link={Link} />
            <AppBanner />
        </>
    )
}
